import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import './App.css';

function About() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [contactFormOpen, setContactFormOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openContactForm = () => {
    setContactFormOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeContactForm = () => {
    setContactFormOpen(false);
    document.body.style.overflow = 'unset';
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    alert('Thank you for contacting us! We will get back to you soon.');
    closeContactForm();
  };

  return (
    <div className="App">
      {/* Navigation */}
      <Navbar activeSection="about" onContactClick={openContactForm} />

      {/* Main Content */}
      <div className="main-content">
        {/* About Us Full Section */}
        <section className="section">
          <h2 className="section-title">About Us</h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                GSC INDIA Farms and Research Center stands as a progressive example of how traditional livestock practices can be transformed through vision, organization, and technology. Founded by B. Chakravarthy, the organization was established with a clear mission: to bring structure, transparency, and modern systems into the largely unorganized farming and meat production sector in India.
              </p>
              <p style={{ marginTop: '1rem' }}>
                From the outset, B. Chakravarthy envisioned a model where farming is treated not merely as a livelihood, but as a professionally managed enterprise. His goal was to organize every stage of the value chain from breeding and feed management to livestock rearing, processing, distribution, and retail under a single, technology-driven framework.
              </p>
              <p style={{ marginTop: '1rem' }}>
                A key strength of GSC INDIA Farms lies in its integration of modern technology with traditional farming wisdom. The farm employs data-driven practices to monitor animal health, growth patterns, feed efficiency, and hygiene standards. Digital record-keeping, process automation, and research-backed feeding programs help ensure consistency in output while reducing waste and improving animal welfare.
              </p>
              <p style={{ marginTop: '1rem' }}>
                The Research Center plays a crucial role in continuous improvement. It focuses on studying better breeding techniques, balanced nutrition, disease prevention, and sustainable farming methods suited to Indian conditions. By aligning research outcomes with on-ground implementation, GSC INDIA Farms bridges the gap between theory and practice.
              </p>
              <p style={{ marginTop: '1rem' }}>
                GSC INDIA Farms is also deeply committed to hygiene, quality, and food safety. Whether supplying live animals, bulk orders, or farm-fresh meat through online and offline channels, strict protocols are followed to ensure ethical handling and premium quality. The emphasis on hygienic, machine-cut meat and transparent sourcing reflects the founder's belief that organized systems are essential for consumer confidence in the modern food ecosystem.
              </p>
              <p style={{ marginTop: '1rem' }}>
                Beyond business, the organization contributes to rural development by creating employment, supporting local farmers, and promoting best practices in livestock management. Training, knowledge-sharing, and fair market access help uplift small-scale farmers and integrate them into a structured supply chain.
              </p>
              <p style={{ marginTop: '1rem' }}>
                Under the leadership of B. Chakravarthy, GSC INDIA Farms and Research Center continues to move forward with a long-term vision: to become a benchmark in organized farming, research-led innovation, and technology integration. By combining tradition with modern management and digital tools, the organization is shaping a sustainable, scalable, and future-ready model for Indian agriculture and livestock enterprises.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Footer with Contact Section */}
      <footer className="section contact-section">
        <div className="contact-content">
          <h2 className="section-title">Contact Us</h2>
          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3 className="contact-title">Corporate Office</h3>
              <p className="contact-details">
                4TH FLOOR PLOT NO 63 AMAR SOCIETY<br />
                KAVURI HILLS MADHAPUR<br />
                HYDERABAD-500081<br />
                TELANGANA, INDIA
              </p>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-tractor"></i>
              </div>
              <h3 className="contact-title">Farm</h3>
              <p className="contact-details">
                SINGAMDODDI VILLAGE SHIVAR<br />
                MIDJIL MANDAL<br />
                MAHABUBNAGAR DIST<br />
                TELANGANA
              </p>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3 className="contact-title">Email</h3>
              <a className="contact-details" href="mailto:contact@gscindiafarms.com">
                contact@gscindiafarms.com
              </a>
            </div>
            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <h3 className="contact-title">Phone</h3>
              <a className="contact-details" href="tel:09959925789">
                9959925789
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 GSC INDIA Farms and Research Center. All rights reserved.</p>
        </div>
      </footer>

            {/* Contact Form Popup */}
      {contactFormOpen && (
        <div className="contact-form-overlay" onClick={closeContactForm}>
          <div className="contact-form-container" onClick={(e) => e.stopPropagation()}>
            <button className="contact-form-close" onClick={closeContactForm}>
              <i className="fas fa-times"></i>
            </button>
            
            <h2 className="contact-form-title">Contact Us</h2>
            
            <form className="contact-form" onSubmit={handleContactSubmit}>
              <div className="form-group">
                <label className="form-label" htmlFor="name">Name</label>
                <input 
                  type="text" 
                  id="name" 
                  className="form-input" 
                  required 
                  placeholder="Your Name"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label" htmlFor="phone">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  className="form-input" 
                  required 
                  placeholder="Your Phone Number"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label" htmlFor="message">Message</label>
                <textarea 
                  id="message" 
                  className="form-textarea" 
                  required 
                  placeholder="Your Message"
                />
              </div>
              
              <button type="submit" className="contact-form-submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Scroll to top button */}
      <div 
        className={`scroll-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
      >
        <i className="fas fa-arrow-up"></i>
      </div>
    </div>
  );
}

export default About;
